import { Inventory2Outlined, LanguageRounded, MoreVert, ReceiptLong } from '@mui/icons-material';
import { Box, Chip, CircularProgress, Divider, IconButton, List, Typography, LinearProgress, Tooltip } from '@mui/material';
import React, { useEffect, useState } from "react";
import { STATUS_SALE } from "../../../helpers/enums";
import { ccyFormat } from "../../../helpers/helper";
import { colorDiego, colorEfectivo, colorJazmin, colorMary, colorMixto, colorSusy, colotTransferencia } from '../../../styles';
import DataCollapse from '../../DataCollapse';
import CashierCollapseContent from './components/CashierCollapseContent';
import CashierSaleCollapseHeader from './components/CashierSaleCollapseHeader';
import DateGroupSection from './components/DateGroupSection';
import SaleRow from './components/SaleRow';
import TicketPreviewModal from '../../tickets/TicketPreviewModal';

const SaleDataCollapseHeader = ({
    sales,
    loading,
    totalSale,
    renderHeaderAmounts,
    hasTransferOrderOrigin,
    transferOrderCount,
    transferStatusLabel,
    transferStatusStyle,
    heldChip,
    onPreviewGroup,
}) => (
    <Typography display='flex' flexDirection='row' justifyContent='space-between' variant='subtitle2' width='100%' alignItems='center'>
        <Box display='flex' component='span' flexDirection='row' alignItems='center'>
            <Typography variant='inherit'>
                <Box component='span' display='flex' paddingLeft={0.3} flexDirection='row' alignItems='center' gap={0.6} flexWrap='wrap'>
                    <Box
                        component='span'
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                        }}
                    >
                        <span>{sales.sales.reduce((acc, item) => acc + item.quantity_sold, 0)}</span>
                        {`- ${sales.sales[0].nameSale}`}
                    </Box>
                    {renderHeaderAmounts()}
                    {heldChip}
                    {hasTransferOrderOrigin && (
                        <Chip
                            icon={<LanguageRounded sx={{ fontSize: '0.82rem !important' }} />}
                            label={transferOrderCount === sales.sales.length ? '' : `${transferOrderCount}`}
                            size='small'
                            variant='filled'
                            sx={{
                                height: 20,
                                '& .MuiChip-icon': {
                                    color: '#FFFFFF'
                                },
                                '& .MuiChip-label': {
                                    px: 0.8,
                                    fontSize: '0.67rem',
                                    fontWeight: 700,
                                    letterSpacing: '.02em'
                                },
                                bgcolor: 'info.dark',
                                color: '#FFFFFF',
                                border: '1px solid',
                                borderColor: 'info.dark',
                                borderRadius: 1.5
                            }}
                        />
                    )}
                    {hasTransferOrderOrigin && (
                        <Chip
                            label={transferStatusLabel}
                            size='small'
                            variant='filled'
                            sx={{
                                height: 20,
                                '& .MuiChip-label': {
                                    px: 0.8,
                                    fontSize: '0.67rem',
                                    fontWeight: 700,
                                    letterSpacing: '.02em'
                                },
                                bgcolor: transferStatusStyle.bg,
                                color: transferStatusStyle.color,
                                border: '1px solid',
                                borderColor: transferStatusStyle.border,
                                borderRadius: 1.5
                            }}
                        />
                    )}
                </Box>
            </Typography>
        </Box>
        {loading ? <CircularProgress size="1rem" /> :
            <Box display='flex' component='span' alignItems='center' gap={0.5}>
                <Typography variant='inherit'>{`$ ${ccyFormat(totalSale)}`}</Typography>
                {onPreviewGroup && (
                    <IconButton
                        size='small'
                        sx={{ p: 0.25 }}
                        onClick={(e) => { e.stopPropagation(); onPreviewGroup(); }}
                    >
                        <ReceiptLong sx={{ fontSize: 16 }} />
                    </IconButton>
                )}
            </Box>}
    </Typography>
)

const SaleDataCollapseContent = ({
    groupByDate,
    styleGroupByDate,
    styleReadonly,
    localSales,
    getColorMoney,
    renderItemTitleWithOver,
    readonly,
    onReturnItem,
    handleItemChecked,
    handleItemReserved,
    handleItemReturn,
    sales,
    stylePast16,
    getPendingBySale,
    onPreviewTicket,
}) => (
    <List sx={{ width: '100%', padding: '0', margin: '0', ...(groupByDate ? styleGroupByDate : styleReadonly) }}>
        <Box sx={{ paddingX: groupByDate ? 0.5 : 2 }}>
            <Box display='flex' flexDirection='column' width='100%'>
                {groupByDate ? <>
                    {localSales && Object.entries(localSales).map(([date, saleGroup]) =>
                        <DateGroupSection
                            key={date}
                            date={date}
                            saless={saleGroup}
                            styleGroupByDate={styleGroupByDate}
                            getColorMoney={getColorMoney}
                            renderItemTitleWithOver={renderItemTitleWithOver}
                            readonly={readonly}
                            onReturnItem={onReturnItem}
                            onDelete={(sale) => handleItemChecked(sale, saleGroup)}
                            onReserve={handleItemReserved}
                            onReturn={handleItemReturn}
                            onPreviewTicket={onPreviewTicket}
                        />
                    )}
                </>
                    : sales.sales.map(sale =>
                        <SaleRow
                            key={sale._id || `${sale.article?.id || sale.article?.name}-${sale.created_at}`}
                            sale={sale}
                            readonly={readonly}
                            onReturnItem={onReturnItem}
                            onDelete={(item) => handleItemChecked(item, sales)}
                            onReserve={handleItemReserved}
                            onReturn={handleItemReturn}
                            stylePast16={stylePast16}
                            getPendingBySale={getPendingBySale}
                            renderItemTitleWithOver={renderItemTitleWithOver}
                            onPreviewTicket={onPreviewTicket}
                        />
                    )}
                <Divider />
            </Box>
        </Box>
    </List>
)


const SaleData = ({ sales, onChecked, colors, loading, readonly = false, tittle, onDeleteItem, groupByDate = false, onReserveItem, onReturnItem, asList = false, mergeActionProps, visualVariant = 'default', showPaidWatermark = false }) => {
    const [checked, setChecked] = useState(false);
    const [colorBackground, setColorBackground] = useState('#fefae0');
    const [colorFont, setColorFont] = useState('#000000');
    const [localSales, setLocalSales] = useState([]);
    const [previewSale, setPreviewSale] = useState(null);

    const handlePreviewTicket = (storeId, idSales) => {
        if (!storeId || !idSales?.length) return;
        setPreviewSale({ storeId, idSales });
    };

    const getColorVendor = (userId) => {
        switch (userId) {
            case "6653654e72dfadfe67d93069": // Jamin MyA
                return colorJazmin;
            case "6657ff19ac884bfd7574f4c1": // Diego
                return colorDiego;
            case "6657ff27ac884bfd7574f4c2": // Mary
                return colorMary;
            case "665d3374fe889a105f3c7587": // Susy
                return colorSusy;
            default:
                return ""
        }
    }

    const getColorMoney = (payments) => {
        var m = payments ? payments.filter(p => p.amount > 0) : [];

        if (m.length === 0) return ''
        if (m.length > 1) return colorMixto
        const name = m[0].name?.toLowerCase()
        if (name === 'efectivo') return colorEfectivo
        if (name === 'transferencia') return colotTransferencia
        return '#607d8b'
    }

    const isTransferOrder = (sale) => sale?.origin === 'transfer_order';

    const colorVendor = sales && sales.sales && sales.sales.length > 0 && getColorVendor(sales.sales[0].userId)

    const mapDate = (sales) => {
        const result = {};

        var newData = sales.map(sale => ({
            ...sale,
            created_sale: sale.created_at,
            created_at: sale.created_at.substring(0, 10)
        }))

        newData.forEach(item => {
            // Asumiendo que `createdAt` es la propiedad con la fecha
            const date = item.created_at

            // Si la fecha aún no existe en el resultado, la inicializamos con un array vacío
            if (!result[date]) {
                result[date] = [];
            }

            // Agregar el item actual al array de la fecha correspondiente
            result[date].push(item);
        });

        setLocalSales(result);
    }

    useEffect(() => {
        mapDate(sales.sales)
    }, [sales])

    const handleChecked = (event, value) => {
        setChecked(value)
        setColorBackground(value ? '#C6EFCE' : '#fefae0')
        setColorFont(value ? '#006100' : '#000000')
        onChecked && onChecked(tittle, value)
    }

    const handleItemChecked = (sale, sales) => {
        console.log(sale)
        onDeleteItem && onDeleteItem(sale, sales)
    }

    const handleItemReserved = sale => {
        console.log(sale)
        onReserveItem && onReserveItem(sale)
    }

    const handleItemReturn = (sale) => {
        onReturnItem && onReturnItem(sale)
    }

    const styleRead = sales.sales[0]?.status === STATUS_SALE.FINISHED ? { color: '#006100', background: '#C6EFCE' } : sales.sales[0]?.status === STATUS_SALE.CANCELED ? { color: '#9C0006', background: '#FFC7CE' } : {}

    const styleReadonly = readonly ? styleRead : { background: colorBackground, color: colorFont, borderRadius: 2 }

    const checkDatesFromSales = () => {
        const today = new Date(); // Fecha actual

        const isExpired = Object.keys(localSales)?.some((dateString) => {
            const date = new Date(dateString); // Convertir la fecha string a un objeto Date
            const diffTime = today - date; // Diferencia en milisegundos
            const diffDays = diffTime / (1000 * 60 * 60 * 24); // Convertir a días
            return diffDays > 7; // Verificar si la diferencia es mayor a 7 días
        });

        return isExpired;
    };

    const checkContainsSaleReturned = () => Object.values(localSales)[0]?.some((sale) => sale.status === STATUS_SALE.RETURNED);

    const hasReturnedSales = checkContainsSaleReturned()
    const hasDateAlert = Object.entries(localSales).length > 2 || checkDatesFromSales()

    const styleGroupByDate = {
        background: hasReturnedSales ? 'red' : hasDateAlert ? '#FFC7CE' : '#C6EFCE',
        color: hasReturnedSales ? 'white' : hasDateAlert ? '#9C0006' : '#006100'
    }

    const deposit = sales.sales.reduce((acc, item) => acc + (item.deposit || 0), 0)

    const totalSale = sales.sales.reduce((acc, item) => acc + (item.prices_sold?.sale_price * item.quantity_sold), 0)
    const totalPendingWithDeposit = deposit > 0 ? Math.max(totalSale - deposit, 0) : 0
    const transferOrderCount = sales.sales.filter((sale) => isTransferOrder(sale)).length;
    const hasTransferOrderOrigin = transferOrderCount > 0;
    const transferOrderStatuses = [...new Set(sales.sales
        .map((sale) => sale?.saleOrder?.status)
        .filter(Boolean)
    )];

    const statusLabelMap = {
        pending_transfer: 'Pendiente',
        payment_review: 'En revisión',
        paid: 'Pagada',
        transfer_received: 'Transferencia recibida',
        approved: 'Aprobada',
        preparing: 'Preparando',
        shipped: 'Enviada',
        delivered: 'Entregada',
        canceled: 'Cancelada'
    };

    const getStatusStyle = (status) => {
        if (status === 'canceled') return { bg: 'error.dark', border: 'error.dark', color: '#FFFFFF' };
        if (status === 'delivered' || status === 'approved' || status === 'paid') return { bg: 'success.dark', border: 'success.dark', color: '#FFFFFF' };
        if (status === 'shipped' || status === 'transfer_received') return { bg: 'info.dark', border: 'info.dark', color: '#FFFFFF' };
        if (status === 'payment_review') return { bg: 'warning.dark', border: 'warning.dark', color: '#FFFFFF' };
        return { bg: 'grey.700', border: 'grey.700', color: '#FFFFFF' };
    };

    const statusIsMixed = transferOrderStatuses.length > 1;
    const mainTransferStatus = transferOrderStatuses[0];
    const transferStatusLabel = !hasTransferOrderOrigin
        ? ''
        : statusIsMixed
            ? `${transferOrderStatuses.length} estados`
            : (statusLabelMap[mainTransferStatus] || mainTransferStatus || 'Sin estado');
    const transferStatusStyle = statusIsMixed
        ? { bg: 'secondary.dark', border: 'secondary.dark', color: '#FFFFFF' }
        : getStatusStyle(mainTransferStatus);

    const formatCompactDate = (value) => {
        if (!value) return null
        const date = new Date(value)
        if (Number.isNaN(date.getTime())) return null
        return date.toLocaleString('es-AR', {
            day: '2-digit',
            month: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        })
    }

    const dates = sales.sales
        .map((sale) => sale.created_sale || sale.created_at || sale.updated_at)
        .filter(Boolean)
        .map((value) => new Date(value))
        .filter((value) => !Number.isNaN(value.getTime()))
        .sort((a, b) => a.getTime() - b.getTime())

    const dateLabel = dates.length === 0
        ? 'Sin fecha registrada'
        : dates.length === 1
            ? formatCompactDate(dates[0])
            : `${formatCompactDate(dates[0])} - ${formatCompactDate(dates[dates.length - 1])}`

    function past16Hs(date) {
        const horaActual = new Date(date).getHours();
        return horaActual >= 16;
    }

    const stylePast16 = (date) => {
        return {
            background: past16Hs(date) ? 'gray' : 'skyblue',
            //color: past16Hs(date) ? '#700c10' : '#084608'
        }
    }

    const getPendingBySale = (sale) => Math.max((sale.prices_sold?.sale_price * sale.quantity_sold) - (sale.deposit || 0), 0)

    const getSecondaryAmountsText = (sale) => {
        const chunks = [];
        if (sale.deposit > 0) {
            chunks.push({ key: 'deposit', label: 'Seña', value: sale.deposit, color: '#9A6700', bg: '#FFF4CC', border: '#F1D37A' })
        }
        if (sale.status === STATUS_SALE.RESERVED && sale.deposit > 0) {
            const pending = getPendingBySale(sale)
            chunks.push({
                key: 'pending',
                label: 'Debe',
                value: pending,
                color: pending > 0 ? '#9C0006' : '#006100',
                bg: pending > 0 ? '#FFC7CE' : '#C6EFCE',
                border: pending > 0 ? '#E5A5AE' : '#9FD5A9'
            })
        }
        return chunks
    }

    const renderItemTitleWithOver = (sale) => {
        const items = getSecondaryAmountsText(sale)
        const label = `${sale.quantity_sold} - ${sale.article.name}`

        if (!items.length) {
            return <span>{label}</span>
        }

        return (
            <Tooltip
                arrow
                placement='top'
                title={
                    <Box display='flex' flexDirection='column' gap={0.25}>
                        {items.map(item => (
                            <Typography key={item.key} variant='caption'>
                                {`${item.label}: $${ccyFormat(item.value)}`}
                            </Typography>
                        ))}
                    </Box>
                }
            >
                <Box component='span' sx={{ textDecoration: 'underline dotted', cursor: 'help', textUnderlineOffset: '2px' }}>
                    {label}
                </Box>
            </Tooltip>
        )
    }

    const renderHeaderAmounts = () => {
        const items = []

        if (deposit > 0) {
            items.push({ key: 'deposit', value: deposit, color: '#9A6700', bg: '#FFF4CC', border: '#F1D37A' })
        }

        if (sales?.sales?.some(sale => sale.status === STATUS_SALE.RESERVED) && deposit > 0) {
            items.push({
                key: 'pending',
                value: totalPendingWithDeposit,
                color: totalPendingWithDeposit > 0 ? '#9C0006' : '#006100',
                bg: totalPendingWithDeposit > 0 ? '#FFC7CE' : '#C6EFCE',
                border: totalPendingWithDeposit > 0 ? '#E5A5AE' : '#9FD5A9'
            })
        }

        if (!items.length) {
            return null
        }

        return (
            <>
                {items.map(item => (
                    <Box
                        key={item.key}
                        component='span'
                        sx={{
                            px: 0.55,
                            borderRadius: 0.8,
                            border: '1px solid',
                            borderColor: item.border,
                            backgroundColor: item.bg,
                            display: 'inline-flex',
                            alignItems: 'center'
                        }}
                    >
                        <Typography component='span' variant='caption' sx={{ color: item.color, lineHeight: 1.2, fontWeight: 700 }}>
                            {`($${ccyFormat(item.value)})`}
                        </Typography>
                    </Box>
                ))}
            </>
        )
    }

    const headerRowStyle = groupByDate
        ? styleGroupByDate
        : hasReturnedSales
            ? { background: 'red', color: 'white' }
            : styleReadonly

    const statusChip = (
        <Chip
            label={sales.sales[0]?.status || 'Sin estado'}
            size='small'
            sx={{
                height: 22,
                '& .MuiChip-label': { px: 0.9, fontWeight: 700, fontSize: '0.7rem' },
                bgcolor: headerRowStyle?.background || '#EEF2F7',
                color: headerRowStyle?.color || '#1F2937',
                borderRadius: 1.5,
            }}
        />
    )

    const transferChip = hasTransferOrderOrigin ? (
        <Chip
            icon={<LanguageRounded sx={{ fontSize: '0.82rem !important' }} />}
            label={transferOrderCount === sales.sales.length ? 'Transfer' : `Transfer ${transferOrderCount}`}
            size='small'
            sx={{
                height: 22,
                '& .MuiChip-icon': { color: '#FFFFFF' },
                '& .MuiChip-label': { px: 0.8, fontSize: '0.7rem', fontWeight: 700 },
                bgcolor: 'info.dark',
                color: '#FFFFFF',
                borderRadius: 1.5,
            }}
        />
    ) : null

    const transferStatusChip = hasTransferOrderOrigin ? (
        <Chip
            label={transferStatusLabel}
            size='small'
            sx={{
                height: 22,
                '& .MuiChip-label': { px: 0.8, fontSize: '0.7rem', fontWeight: 700 },
                bgcolor: transferStatusStyle.bg,
                color: transferStatusStyle.color,
                borderRadius: 1.5,
            }}
        />
    ) : null

    const heldCount = sales.sales.filter(s => s.held).length
    const heldChip = heldCount > 0 ? (
        <Chip
            icon={<Inventory2Outlined sx={{ fontSize: '0.8rem !important', color: '#283593 !important' }} />}
            label={heldCount === sales.sales.length ? 'En depósito' : `${heldCount} en depósito`}
            size='small'
            sx={{
                height: 22,
                '& .MuiChip-label': { px: 0.8, fontSize: '0.7rem', fontWeight: 700 },
                bgcolor: '#e8eaf6',
                color: '#283593',
                borderRadius: 1.5,
            }}
        />
    ) : null

    return (<>
        {sales.sales.length > 0 && <Box display='flex' flexDirection='row'>
            {colorVendor !== "" && <Box sx={{ background: colorVendor, width: 5 }} />}
            {mergeActionProps && (
                <Box
                    display='flex'
                    alignItems='center'
                    pl={0}
                    pr={0}
                    pt={0}
                    sx={{
                        background: headerRowStyle?.background || 'transparent',
                        color: headerRowStyle?.color || 'inherit',
                        mr: -0.35,
                    }}
                >
                    <IconButton
                        size='small'
                        sx={{
                            p: 0,
                            width: 14,
                            height: 14,
                            bgcolor: 'inherit',
                            color: 'inherit',
                            '&:hover': {
                                bgcolor: 'inherit'
                            }
                        }}
                        onClick={(event) => {
                            event.preventDefault()
                            event.stopPropagation()
                            mergeActionProps.onClick(event)
                        }}
                    >
                        <MoreVert sx={{ fontSize: 16 }} />
                    </IconButton>
                </Box>
            )}
            <Box display='flex' flexDirection='column' width='100%' sx={{ position: 'relative' }}>
                {showPaidWatermark && (
                    <div className="paid-watermark">PAGADO</div>
                )}
                {deposit !== 0 && sales?.sales?.some(sale => sale.status === STATUS_SALE.RESERVED) && <LinearProgress variant="determinate" value={(deposit/totalSale)*100} sx={{ height: 2 }} color='success'/>}
                <DataCollapse
                    asList={asList}
                    colorBackground={colorBackground}
                    checked={checked}
                    handleChecked={handleChecked}
                    loading={loading}
                    style={headerRowStyle}
                    readonly={readonly || isTransferOrder(sales.sales[0])}
                    paddingX={readonly ? 1 : 0}
                    variant={visualVariant}
                    Header={() => visualVariant === 'cashier'
                        ? <CashierSaleCollapseHeader
                            nameSale={sales.sales[0].nameSale}
                            totalSale={totalSale}
                            totalQuantity={sales.sales.reduce((acc, item) => acc + item.quantity_sold, 0)}
                            orderCount={sales.sales.length}
                            dateLabel={dateLabel}
                            amountBadges={renderHeaderAmounts()}
                            statusChip={statusChip}
                            transferChip={transferChip}
                            transferStatusChip={transferStatusChip}
                            heldChip={heldChip}
                            saleStatus={sales.sales[0]?.status}
                          />
                        : <SaleDataCollapseHeader
                            sales={sales}
                            loading={loading}
                            totalSale={totalSale}
                            renderHeaderAmounts={renderHeaderAmounts}
                            hasTransferOrderOrigin={hasTransferOrderOrigin}
                            transferOrderCount={transferOrderCount}
                            transferStatusLabel={transferStatusLabel}
                            transferStatusStyle={transferStatusStyle}
                            heldChip={heldChip}
                            onPreviewGroup={() => handlePreviewTicket(
                                sales.sales[0]?.store_id,
                                sales.sales.map(s => s.idSale).filter(Boolean)
                            )}
                          />}
                    Content={() => visualVariant === 'cashier'
                        ? <CashierCollapseContent
                            groupByDate={groupByDate}
                            localSales={localSales}
                            sales={sales}
                            getPendingBySale={getPendingBySale}
                          />
                        : <SaleDataCollapseContent
                            groupByDate={groupByDate}
                            styleGroupByDate={styleGroupByDate}
                            styleReadonly={styleReadonly}
                            localSales={localSales}
                            getColorMoney={getColorMoney}
                            renderItemTitleWithOver={renderItemTitleWithOver}
                            readonly={readonly}
                            onReturnItem={onReturnItem}
                            handleItemChecked={handleItemChecked}
                            handleItemReserved={handleItemReserved}
                            handleItemReturn={handleItemReturn}
                            sales={sales}
                            stylePast16={stylePast16}
                            getPendingBySale={getPendingBySale}
                            onPreviewTicket={handlePreviewTicket}
                          />}
                />
            </Box>
        </Box>}
      <TicketPreviewModal
        storeId={previewSale?.storeId}
        idSales={previewSale?.idSales}
        open={!!previewSale}
        onClose={() => setPreviewSale(null)}
      />
    </>)
}

export default SaleData;